import Image from './src/image2.mjs';
export { imageEmits, imageProps } from './src/image.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElImage = withInstall(Image);

export { ElImage, ElImage as default };
//# sourceMappingURL=index.mjs.map
